/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AuditActionType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  Enable = 'Enable',
  Disable = 'Disable'
}
